module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Brisbin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When "), _c('B', [_c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Terri Brisbin")], 1), _vm._v(" is not being a glamorous romance author or in a deadline-writing-binge-o'-mania, she's a wife, mom, GRANDMOM and dental hygienist in the southern New Jersey area. A three-time RWA RITA® finalist,"), _c('B', [_vm._v(" Terri ")]), _vm._v("has had more than 50 historical and paranormal romance novels, novellas and short stories published since 1998. You can visit her website:www.terribrisbin.com to learn more about her.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZIqDCQ/tc-custom/9781426878497.jpg?1728259609451",
      "alt": "This image is the cover for the book Duchess's Next Husband"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Duchess's Next Husband\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("All Miranda Warfield had ever wanted was to be awife to a man, not a title, but her marriage toAdrian, Duke of Windmere, had been merely a politeton alliance for years. Now, miraculously, the tender,loving Adrian of her youth had returned, making herfeel like a bride again. But dare she trust theirrekindled romance? For why was Adrian suddenlyarranging clandestine meetings with his solicitor?And asking her opinions on several marriageablegentlemen of the ton? Did her husband's eyes betraya secret his ardent lips denied…?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0